import React from "react";
var __jsx = React.createElement;
import { createContext, useEffect, useState } from "react";
import useWebsocket from "../../hooks/useWebsocket";
import { get, isEmpty, size } from "lodash";
import { differenceInMinutes } from "date-fns";
import constants from "../../utils/constants";
import { useGetGateways } from "./services";
import { useAuth } from "@qure/qure-auth";
export var GatewayContext = /*#__PURE__*/createContext({});
export var GatewayContextProvider = function GatewayContextProvider(props) {
  var children = props.children;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var isLoggedIn = get(userInfo, ["authenticated"], false);
  var _useState = useState([]),
    gatewayData = _useState[0],
    setGatewayData = _useState[1];
  var _useGetGateways = useGetGateways(isLoggedIn),
    gateway_data = _useGetGateways.data,
    refetchGatewayData = _useGetGateways.refetch,
    isLoading = _useGetGateways.isLoading;
  var _useWebsocket = useWebsocket("/gateways/".concat(userInfo === null || userInfo === void 0 ? void 0 : userInfo.username, "/"), !isEmpty(userInfo)),
    wsData = _useWebsocket.wsData;
  var formatTimeDifference = function formatTimeDifference(timeDifference) {
    var formattedDifference;
    if (timeDifference < 60) {
      formattedDifference = "".concat(timeDifference, "m");
    } else {
      var hours = Math.floor(timeDifference / 60);
      var minutes = timeDifference % 60;
      formattedDifference = "".concat(hours, "h ").concat(minutes, "m");
    }
    return formattedDifference;
  };
  var modifyGatewayData = function modifyGatewayData(gatewayData) {
    var modified_data = gatewayData === null || gatewayData === void 0 ? void 0 : gatewayData.map(function (gw) {
      var _gw$gateway, _gw$gateway2, _gw$gateway3, _gw$gateway4, _gw$gateway5;
      return {
        uuid: gw === null || gw === void 0 || (_gw$gateway = gw.gateway) === null || _gw$gateway === void 0 ? void 0 : _gw$gateway.uuid,
        gateway_name: gw === null || gw === void 0 || (_gw$gateway2 = gw.gateway) === null || _gw$gateway2 === void 0 ? void 0 : _gw$gateway2.gateway_name,
        last_online: gw === null || gw === void 0 ? void 0 : gw.last_online,
        workspace_id: gw === null || gw === void 0 || (_gw$gateway3 = gw.gateway) === null || _gw$gateway3 === void 0 || (_gw$gateway3 = _gw$gateway3.workspace) === null || _gw$gateway3 === void 0 ? void 0 : _gw$gateway3.id,
        workspace_name: gw === null || gw === void 0 || (_gw$gateway4 = gw.gateway) === null || _gw$gateway4 === void 0 || (_gw$gateway4 = _gw$gateway4.workspace) === null || _gw$gateway4 === void 0 ? void 0 : _gw$gateway4.name,
        time_difference: differenceInMinutes(new Date(), new Date(gw === null || gw === void 0 ? void 0 : gw.last_online)),
        gateway_poc_phone: gw === null || gw === void 0 || (_gw$gateway5 = gw.gateway) === null || _gw$gateway5 === void 0 ? void 0 : _gw$gateway5.gateway_poc_phone
      };
    });
    var groupedData = modified_data === null || modified_data === void 0 ? void 0 : modified_data.reduce(function (acc, item) {
      var existingItem = acc.find(function (group) {
        return group.workspace_id === item.workspace_id;
      });
      if (existingItem) {
        if (item.time_difference > 16) {
          existingItem.offline_gateway_count = existingItem.offline_gateway_count + 1;
        }
        existingItem.gateway.push({
          uuid: item.uuid,
          last_online: item.last_online,
          gateway_name: item.gateway_name,
          time_difference: item.time_difference,
          gateway_poc_phone: item === null || item === void 0 ? void 0 : item.gateway_poc_phone
        });
      } else {
        acc.push({
          workspace_id: item.workspace_id,
          workspace_name: item.workspace_name,
          offline_gateway_count: item.time_difference > 16 ? 1 : 0,
          gateway: [{
            uuid: item.uuid,
            last_online: item.last_online,
            gateway_name: item.gateway_name,
            time_difference: item.time_difference,
            gateway_poc_phone: item === null || item === void 0 ? void 0 : item.gateway_poc_phone
          }]
        });
      }
      return acc;
    }, []);
    return groupedData;
  };
  var offlineGateway = function offlineGateway(gatewayData) {
    var offlineData = [];
    gatewayData === null || gatewayData === void 0 || gatewayData.map(function (gw) {
      var timeDifference = differenceInMinutes(new Date(), new Date(gw.last_online));
      if (timeDifference >= constants.GATEWAY_TIME.TIME_DIFFERENCE) {
        offlineData.push(gw);
      }
    });
    return offlineData;
  };
  useEffect(function () {
    setGatewayData((gateway_data === null || gateway_data === void 0 ? void 0 : gateway_data.gateways) || []);
  }, [gateway_data]);
  useEffect(function () {
    if (wsData) {
      if (wsData.action === "gateway_status_update") {
        var gatewayContent = get(wsData, ["content", "gateways"], []);
        setGatewayData(gatewayContent);
      }
    }
  }, [wsData]);
  return /*#__PURE__*/React.createElement(GatewayContext.Provider, {
    value: {
      gatewayData: modifyGatewayData(gatewayData),
      offlineGatewayData: modifyGatewayData(offlineGateway(gatewayData)),
      totalGateway: size(gatewayData),
      offlineGatewayCount: size(offlineGateway(gatewayData)),
      formatTimeDifference: formatTimeDifference,
      refetchGatewayData: refetchGatewayData,
      isLoading: isLoading
    }
  }, children);
};